import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import GlobalsSettingsComponent from '../components/global.component';
import { selectGlobalSettingsQueryItems } from '../../../../../../redux/global-settings/selector';
import { globalSettings } from '../../../../../../redux/global-settings/action';

const ManagementGlobalSettings = () => {
  const dispatch = useAppDispatch()
  const globalSettingsQuery = useSelector(selectGlobalSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectGlobalSettings, setSelectGlobalSettings] = useState<any>({
    "DMSSettings": {
      "IsStorageAccountEnabled": false,
      "IsCDNServiceEnabled": false,
      "EnableFolderForVendor": false,
      "EnableNewlyAddedFolders": false
    },
    "EmailSettings": {
      "IsEmailServiceEnabled": false
    },
    "SMSSettings": {
      "IsSMSServiceEnabled": false
    },
    "BarCodeSettings": {
      "IsBarCodeServiceEnabled": false
    },
    "QRCodeSettings": {
      "IsQRCodeServiceEnabled": false
    },
    "NoteSettings": {
      "IsNotesEnabled": false
    },
    "GlobalTenantSettings": {
      "EnableZeoValueTransactions": false,
      "MaintainBillWiseDetails": false,
      "EnableGST": false,
      "EnableServiceTax": false,
      "EnableBankingFeatures": false,
      "SETALTERTransactionTypes": false
    },
    "GlobalLogSettings": {
      "EnableGatewayCommunicationLogs": false,
      "EnableFluentValidationLogs": false,
      "EnableHandlerLogs": false,
      "EnableEnterpriseMangerLogs": false,
      "EnableDataManagerLogs": false,
      "EnableReadModelLogs": false,
      "EnableSnapShotLogs": false,
      "EnablePublishToCloudLogs": false,
      "EnableCatalogPublishLogs": false,
      "EnableIncrementalSyncLogs": false
    }
  });

  const fetchGlobalSettingsQueryById = () => {
    dispatch(globalSettings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/V6.1/setting/global-settings/global/query`,
      entity: 'globalSettings',
      jsonData: {
        Context: {},
        Records: [{}]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectGlobalSettings({ ...selectGlobalSettings, [fields[0]]: value });
  }

  useEffect(() => {
    fetchGlobalSettingsQueryById();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectGlobalSettings(globalSettingsQuery?.result?.items)
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const globalSettingsData = {
      Id: selectGlobalSettings?.Id || 0,
      DMSSettings: {
        IsStorageAccountEnabled: selectGlobalSettings?.DMSSettings?.IsStorageAccountEnabled || false,
        IsCDNServiceEnabled: selectGlobalSettings?.DMSSettings?.IsCDNServiceEnabled || false,
        EnableFolderForVendor: selectGlobalSettings?.DMSSettings?.EnableFolderForVendor || false,
        EnableNewlyAddedFolders: selectGlobalSettings?.DMSSettings?.EnableNewlyAddedFolders || false,
      },
      EmailSettings: {
        IsEmailServiceEnabled: selectGlobalSettings?.EmailSettings?.IsEmailServiceEnabled || false,
      },
      SMSSettings: {
        IsSMSServiceEnabled: selectGlobalSettings?.SMSSettings?.IsSMSServiceEnabled || false,
      },
      BarCodeSettings: {
        IsBarCodeServiceEnabled: selectGlobalSettings?.BarCodeSettings?.IsBarCodeServiceEnabled || false,
      },
      QRCodeSettings: {
        IsQRCodeServiceEnabled: selectGlobalSettings?.QRCodeSettings?.IsQRCodeServiceEnabled || false,
      },
      NoteSettings: {
        IsNotesEnabled: selectGlobalSettings?.NoteSettings?.IsNotesEnabled || false,
      },
      GlobalTenantSettings: {
        EnableZeoValueTransactions: selectGlobalSettings?.GlobalTenantSettings?.EnableZeoValueTransactions || false,
        MaintainBillWiseDetails: selectGlobalSettings?.GlobalTenantSettings?.MaintainBillWiseDetails || false,
        EnableGST: selectGlobalSettings?.GlobalTenantSettings?.EnableGST || false,
        EnableServiceTax: selectGlobalSettings?.GlobalTenantSettings?.EnableServiceTax || false,
        EnableBankingFeatures: selectGlobalSettings?.GlobalTenantSettings?.EnableBankingFeatures || false,
        SETALTERTransactionTypes: selectGlobalSettings?.GlobalTenantSettings?.SETALTERTransactionTypes || false,
      },
      GlobalLogSettings: {
        EnableGatewayCommunicationLogs: selectGlobalSettings?.GlobalLogSettings?.EnableGatewayCommunicationLogs || false,
        EnableFluentValidationLogs: selectGlobalSettings?.GlobalLogSettings?.EnableFluentValidationLogs || false,
        EnableHandlerLogs: selectGlobalSettings?.GlobalLogSettings?.EnableHandlerLogs || false,
        EnableEnterpriseMangerLogs: selectGlobalSettings?.GlobalLogSettings?.EnableEnterpriseMangerLogs || false,
        EnableDataManagerLogs: selectGlobalSettings?.GlobalLogSettings?.EnableDataManagerLogs || false,
        EnableReadModelLogs: selectGlobalSettings?.GlobalLogSettings?.EnableReadModelLogs || false,
        EnableSnapShotLogs: selectGlobalSettings?.GlobalLogSettings?.EnableSnapShotLogs || false,
        EnablePublishToCloudLogs: selectGlobalSettings?.GlobalLogSettings?.EnablePublishToCloudLogs || false,
        EnableCatalogPublishLogs: selectGlobalSettings?.GlobalLogSettings?.EnableCatalogPublishLogs || false,
        EnableIncrementalSyncLogs: selectGlobalSettings?.GlobalLogSettings?.EnableIncrementalSyncLogs || false,
      },
    };

    try {
      setIsSubmitting(true);
      await dispatch(globalSettings.resetAction({ actionType: "update" }));
      await dispatch(
        globalSettings.update({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/V6.1/setting/global-settings/global`,
          entity: "globalSettings",
          jsonData: {
            Context: {},
            Records: [globalSettingsData],
          },
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isLoading ? <PageLoader /> :
        <GlobalsSettingsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectGlobalSettings={selectGlobalSettings}
          handleFormSubmit={handleFormSubmit}
          isSubmitting={isSubmitting}
        />
      }
    </>
  )
};

export default ManagementGlobalSettings;